import { Field } from 'redux-form';
import SwitchInput from './SwitchInput';

const SwitchField = (props) => {
  return (
    <div>
      <Field
        {...props}
        component={SwitchInput}
      />
    </div>);
}

export default SwitchField;